import { render, staticRenderFns } from "./demo-composit-form.vue?vue&type=template&id=871a7de4&scoped=true"
import script from "./demo-composit-form.vue?vue&type=script&lang=js"
export * from "./demo-composit-form.vue?vue&type=script&lang=js"
import style0 from "./demo-composit-form.vue?vue&type=style&index=0&id=871a7de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871a7de4",
  null
  
)

export default component.exports